export const scrollNextField = () => {
  // Manual form: scroll to the current active field, or the email consent field if email is filled
  const current = document.querySelector('.carlead-creation-field-container--is-current');
  const lastField = document.querySelector('.carlead-creation-form-button');
  const emailFilled = document.querySelector('.carlead-creation-field-container--email.carlead-creation-field-container--is-selected + .carlead-creation-field-container--EMAIL_EVALUATION_CONSENT');
  // Chat mode (for Conversational Lead): manual form fields won't exist, scroll to the chat UI instead
  const chatWrapper = document.querySelector('.conversational-lead__chat-wrapper');

  // A collapsed/hidden container (e.g. the mainType split-type selectors that
  // aren't rendered on license-plate funnels) has a zero-size box, so its
  // getBoundingClientRect().top is 0 — scrolling to it would resolve to the
  // current scroll position and appear to do nothing.
  const isVisible = element => !!element && element.getBoundingClientRect().height > 0;

  // Walk back to the previous *visible* element sibling, skipping collapsed
  // containers and text nodes (previousElementSibling never returns text nodes).
  const previousVisibleSibling = element => {
    let sibling = element && element.previousElementSibling;
    while (sibling && !isVisible(sibling)) {
      sibling = sibling.previousElementSibling;
    }
    return sibling;
  };
  const scrollToElement = element => {
    const offset = 100;
    const elementTop = element.getBoundingClientRect().top + window.scrollY;
    const targetPosition = elementTop - offset;
    window.scrollTo({
      top: targetPosition,
      behavior: 'smooth'
    });
  };

  // Pick the best available target in order of priority; guard against all being null
  const target = emailFilled || current && (previousVisibleSibling(current) || current) || chatWrapper || lastField;

  // Only scroll to a target that has a real layout box; otherwise fall back to
  // the current field so the scroll never silently no-ops on a hidden element.
  if (isVisible(target)) {
    scrollToElement(target);
  } else if (current) {
    scrollToElement(current);
  }
};